export function arrivageReducer(state = { 
},{
    type,
    payload
}){
    
    switch(type){
        case "NEW_ARRIVAGE": 
        case "UPDATE_ARRIVAGE": 
            return {
                ...state,
                [payload.id]: payload
            }
        case "RECEIVED_ARRIVAGE":        
            return {
                ...state,
                [payload]: {
                    ...state[payload],
                    received: true
                }
            }
        case "GET_ARRIVAGES":        
            return payload;
        
        case "DELETE_ARRIVAGE":
            const { [payload]: deleted, ...newState } = state;
            return newState;
        default:
            return state;
    }
    
}